// generated from 3_735 samples

import { z } from "zod";

export const addedEmailAddressTriggerGetSchema = z.object({
  event_type: z.literal("TrackedUserBehavior::AddedEmailAddress"),
});
